import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "App-User-Right" }
const _hoisted_2 = {
  "f-w-700": "",
  "txt-center": "",
  "m-tb-0": ""
}
const _hoisted_3 = {
  key: 0,
  "f-w-600": "",
  "txt-center": "",
  "m-tb-0": ""
}
const _hoisted_4 = {
  key: 0,
  "txt-center": "",
  "mute-secondary": ""
}
const _hoisted_5 = {
  "m-tb-1": "",
  "txt-center": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_ent_standing = _resolveComponent("app-ent-standing")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$filters.capitalize(_ctx.user.firstName)) + " " + _toDisplayString(_ctx.$filters.capitalize(_ctx.user.lastName)), 1)
    ]),
    _createElementVNode("div", null, [
      (_ctx.user.headine || _ctx.user.areaOfExpertise)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.$filters.capitalize(_ctx.user.headine || _ctx.user.areaOfExpertise)), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.user.location)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.user.location.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_space, { size: 10 }, {
        default: _withCtx(() => [
          (_ctx.user.linkedin)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                style: {"color":"rgb(10, 102, 194)","background":"rgba(10, 102, 194, 0.1)"},
                "as-pointer": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyContent(_ctx.user.linkedIn))),
                "is-all-borderless": "",
                round: ""
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "el-icon-link" }, null, -1),
                  _createTextVNode(" LinkedIn ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.portfolio)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                "as-pointer": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyContent(_ctx.user.portfolio))),
                type: "primary",
                "is-all-borderless": "",
                round: ""
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "el-icon-link" }, null, -1),
                  _createTextVNode(" Portfolio ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_app_ent_standing, {
        labelSelf: `${_ctx.$filters.capitalize(_ctx.user.firstName)} (You)`,
        standingSelf: _ctx.user.standing,
        size: "mini"
      }, null, 8, ["labelSelf", "standingSelf"])
    ])
  ]))
}